import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

export interface StartOption {
	classes: string[];
	title: string;
	icon: string;
	message: string;
	button: string;
	disabled: boolean;
	on(): void;
}

@Component({
	selector: "stages-files-start",
	templateUrl: "./files-start.component.html",
	styleUrls: ["./files-start.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, NgClass],
})
export class FilesStartComponent {
	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	headline?: string;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	translateNone?: string;

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	startOptions!: StartOption[];
}
